
export default {
  props: ["modelValue"],
  emits: ["update:modelValue"],
};
